export const messages = {
  'pt-BR': {
    nav: {
      home: 'Início',
      about: 'Sobre',
      services: 'Serviços',
      projects: 'Projetos',
      contact: 'Contato'
    },
    hero: {
      title: 'Soluções Inovadoras em Desenvolvimento de Software',
      subtitle: 'Desenvolvemos sistemas personalizados, web, desktop e mobile para impulsionar seu negócio.',
      cta: 'Fale Conosco'
    },
    about: {
      title: 'Sobre a RC Inovações',
      description: 'A RC Inovações é uma empresa especializada em desenvolvimento de sistemas, focada em entregar soluções tecnológicas inovadoras e de alta qualidade. Nossa equipe de profissionais qualificados está preparada para atender às necessidades específicas do seu negócio, criando sistemas sob medida que potencializam a eficiência operacional e impulsionam o crescimento.',
      mission: 'Missão',
      missionText: 'Desenvolver soluções tecnológicas que transformem e otimizem processos, gerando valor para nossos clientes.',
      vision: 'Visão',
      visionText: 'Ser referência em desenvolvimento de sistemas personalizados, reconhecida pela excelência e inovação.',
      values: 'Valores',
      valuesText: 'Inovação, Qualidade, Comprometimento, Ética e Satisfação do Cliente.'
    },
    services: {
      title: 'Nossos Serviços',
      webDev: {
        title: 'Desenvolvimento Web',
        description: 'Criamos websites e sistemas web responsivos, modernos e otimizados para oferecer a melhor experiência aos usuários. Utilizamos as tecnologias mais avançadas do mercado.'
      },
      desktopDev: {
        title: 'Desenvolvimento Desktop',
        description: 'Desenvolvemos aplicações desktop robustas e eficientes, ideais para uso corporativo, com interfaces intuitivas e alto desempenho.'
      },
      mobileDev: {
        title: 'Desenvolvimento Mobile',
        description: 'Criamos aplicativos móveis nativos e híbridos para iOS e Android, com design moderno e excelente experiência do usuário.'
      },
      customSystems: {
        title: 'Sistemas Personalizados',
        description: 'Desenvolvemos sistemas sob medida para atender às necessidades específicas do seu negócio, automatizando processos e aumentando a produtividade.'
      }
    },
    projects: {
      title: 'Projetos Realizados',
      viewMore: 'Ver mais'
    },
    testimonials: {
      title: 'Depoimentos',
      client1: {
        name: 'João Silva',
        company: 'Empresa ABC',
        text: 'A RC Inovações entregou um sistema que superou nossas expectativas. A equipe foi extremamente profissional e atenciosa durante todo o processo.'
      },
      client2: {
        name: 'Maria Oliveira',
        company: 'Comércio XYZ',
        text: 'O aplicativo desenvolvido pela RC Inovações transformou nossa operação. Estamos muito satisfeitos com o resultado e com o suporte contínuo.'
      },
      client3: {
        name: 'Carlos Santos',
        company: 'Indústria 123',
        text: 'Recomendo fortemente os serviços da RC Inovações. O sistema personalizado que criaram para nossa empresa foi fundamental para o crescimento do negócio.'
      }
    },
    contact: {
      title: 'Entre em Contato',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      subject: 'Assunto',
      message: 'Mensagem',
      send: 'Enviar',
      address: 'Endereço',
      phoneContact: 'Telefone',
      emailContact: 'E-mail'
    },
    footer: {
      rights: 'Todos os direitos reservados',
      privacy: 'Política de Privacidade',
      terms: 'Termos de Uso'
    },
    privacyPolicy: {
      title: 'Política de Privacidade',
      lastUpdate: 'Última atualização',
      introduction: {
        title: 'Introdução',
        content: 'A RC Inovações está comprometida em proteger a privacidade dos usuários do nosso site. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos as informações pessoais que você compartilha conosco ao utilizar nosso site e serviços.'
      },
      dataCollection: {
        title: 'Coleta de Dados',
        content: 'Podemos coletar os seguintes tipos de informações:',
        items: [
          'Informações de contato (como nome, e-mail, telefone) quando você preenche nosso formulário de contato',
          'Informações de uso do site através de cookies e tecnologias similares',
          'Informações que você voluntariamente compartilha conosco em comunicações diretas'
        ]
      },
      dataUse: {
        title: 'Uso dos Dados',
        content: 'Utilizamos as informações coletadas para:',
        items: [
          'Responder às suas solicitações e fornecer os serviços requisitados',
          'Melhorar nosso site e serviços',
          'Enviar informações sobre nossos serviços quando solicitado',
          'Cumprir obrigações legais e regulatórias'
        ]
      },
      cookies: {
        title: 'Cookies e Tecnologias Similares',
        content: 'Utilizamos cookies e tecnologias similares para melhorar sua experiência em nosso site. Você pode configurar seu navegador para recusar cookies, mas isso pode limitar sua experiência no site.'
      },
      thirdParties: {
        title: 'Compartilhamento com Terceiros',
        content: 'Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros para fins comerciais. Podemos compartilhar informações com prestadores de serviços que nos ajudam a operar nosso site e fornecer serviços, sempre sob rigorosos termos de confidencialidade.'
      },
      security: {
        title: 'Segurança',
        content: 'Implementamos medidas técnicas e organizacionais para proteger suas informações pessoais contra acesso não autorizado, perda acidental ou uso indevido. No entanto, nenhuma transmissão de dados pela internet ou sistema de armazenamento é completamente seguro.'
      },
      userRights: {
        title: 'Seus Direitos',
        content: 'Você tem os seguintes direitos em relação aos seus dados pessoais:',
        items: [
          'Direito de acesso às informações que temos sobre você',
          'Direito de correção de dados imprecisos',
          'Direito de exclusão de seus dados pessoais',
          'Direito de restringir ou se opor ao processamento de seus dados',
          'Direito de portar seus dados para outro serviço'
        ]
      },
      changes: {
        title: 'Alterações nesta Política',
        content: 'Podemos atualizar esta Política de Privacidade de tempos em tempos. Recomendamos que você revise esta página periodicamente para se manter informado sobre quaisquer alterações.'
      },
      contact: {
        title: 'Contato',
        content: 'Se você tiver dúvidas ou preocupações sobre esta Política de Privacidade ou sobre como tratamos seus dados pessoais, entre em contato conosco através do e-mail contato@rcinovacoes.com.br.'
      }
    },
    termsOfUse: {
      title: 'Termos de Uso',
      lastUpdate: 'Última atualização',
      introduction: {
        title: 'Introdução',
        content: 'Bem-vindo ao site da RC Inovações. Estes Termos de Uso regem seu acesso e uso do nosso site e de todos os serviços relacionados. Ao acessar ou usar nosso site, você concorda em ficar vinculado a estes termos.'
      },
      acceptance: {
        title: 'Aceitação dos Termos',
        content: 'Ao usar nosso site, você confirma que leu, entendeu e concordou com estes Termos de Uso. Se você não concordar com qualquer parte destes termos, pedimos que não utilize nosso site ou serviços.'
      },
      services: {
        title: 'Serviços Oferecidos',
        content: 'A RC Inovações oferece os seguintes serviços:',
        items: [
          'Desenvolvimento de sistemas web',
          'Desenvolvimento de aplicações desktop',
          'Desenvolvimento de aplicativos mobile',
          'Sistemas personalizados para empresas',
          'Consultoria em tecnologia da informação'
        ]
      },
      intellectualProperty: {
        title: 'Propriedade Intelectual',
        content: 'Todo o conteúdo disponível no site da RC Inovações, incluindo textos, gráficos, logotipos, ícones, imagens, clips de áudio, downloads digitais e compilações de dados, é propriedade da RC Inovações ou de seus fornecedores de conteúdo e está protegido pelas leis brasileiras e internacionais de direitos autorais.'
      },
      userConduct: {
        title: 'Conduta do Usuário',
        content: 'Ao utilizar nosso site, você concorda em não:',
        prohibitions: [
          'Violar quaisquer leis aplicáveis',
          'Distribuir vírus ou qualquer outro código malicioso',
          'Interferir ou interromper o funcionamento do site',
          'Coletar dados pessoais de outros usuários',
          'Utilizar o site para fins ilegais ou não autorizados'
        ]
      },
      liability: {
        title: 'Limitações de Responsabilidade',
        content: 'A RC Inovações não se responsabiliza por danos indiretos, acidentais ou consequentes, incluindo lucros cessantes, resultantes do uso ou da incapacidade de usar nosso site ou serviços.'
      },
      thirdPartyLinks: {
        title: 'Links de Terceiros',
        content: 'Nosso site pode conter links para sites de terceiros. Não temos controle sobre o conteúdo e práticas desses sites e não nos responsabilizamos por suas políticas de privacidade ou práticas.'
      },
      modifications: {
        title: 'Modificações nos Termos',
        content: 'Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. Alterações significativas serão notificadas através de nosso site. Seu uso contínuo do site após tais modificações constitui aceitação dos novos termos.'
      },
      termination: {
        title: 'Rescisão',
        content: 'Podemos encerrar ou suspender seu acesso ao nosso site imediatamente, sem aviso prévio, por qualquer motivo, incluindo violação destes Termos de Uso.'
      },
      governingLaw: {
        title: 'Lei Aplicável',
        content: 'Estes Termos de Uso são regidos e interpretados de acordo com as leis do Brasil. Qualquer disputa decorrente destes termos será submetida à jurisdição exclusiva dos tribunais de São Luis de Montes Belos, Goiás.'
      },
      contact: {
        title: 'Contato',
        content: 'Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco através do e-mail contato@rcinovacoes.com.br.'
      }
    },
    meta: {
      privacyPolicy: 'RC INOVAÇÕES - Política de Privacidade',
      termsOfUse: 'RC INOVAÇÕES - Termos de Uso'
    }
  },
  'pt-PT': {
    nav: {
      home: 'Início',
      about: 'Sobre',
      services: 'Serviços',
      projects: 'Projetos',
      contact: 'Contacto'
    },
    hero: {
      title: 'Soluções Inovadoras em Desenvolvimento de Software',
      subtitle: 'Desenvolvemos sistemas personalizados, web, desktop e mobile para impulsionar o seu negócio.',
      cta: 'Contacte-nos'
    },
    about: {
      title: 'Sobre a RC Inovações',
      description: 'A RC Inovações é uma empresa especializada em desenvolvimento de sistemas, focada em entregar soluções tecnológicas inovadoras e de alta qualidade. A nossa equipa de profissionais qualificados está preparada para atender às necessidades específicas do seu negócio, criando sistemas à medida que potencializam a eficiência operacional e impulsionam o crescimento.',
      mission: 'Missão',
      missionText: 'Desenvolver soluções tecnológicas que transformem e otimizem processos, gerando valor para os nossos clientes.',
      vision: 'Visão',
      visionText: 'Ser referência em desenvolvimento de sistemas personalizados, reconhecida pela excelência e inovação.',
      values: 'Valores',
      valuesText: 'Inovação, Qualidade, Comprometimento, Ética e Satisfação do Cliente.'
    },
    services: {
      title: 'Nossos Serviços',
      webDev: {
        title: 'Desenvolvimento Web',
        description: 'Criamos websites e sistemas web responsivos, modernos e otimizados para oferecer a melhor experiência aos utilizadores. Utilizamos as tecnologias mais avançadas do mercado.'
      },
      desktopDev: {
        title: 'Desenvolvimento Desktop',
        description: 'Desenvolvemos aplicações desktop robustas e eficientes, ideais para uso corporativo, com interfaces intuitivas e alto desempenho.'
      },
      mobileDev: {
        title: 'Desenvolvimento Mobile',
        description: 'Criamos aplicativos móveis nativos e híbridos para iOS e Android, com design moderno e excelente experiência do utilizador.'
      },
      customSystems: {
        title: 'Sistemas Personalizados',
        description: 'Desenvolvemos sistemas à medida para atender às necessidades específicas do seu negócio, automatizando processos e aumentando a produtividade.'
      }
    },
    projects: {
      title: 'Projetos Realizados',
      viewMore: 'Ver mais'
    },
    testimonials: {
      title: 'Depoimentos',
      client1: {
        name: 'João Silva',
        company: 'Empresa ABC',
        text: 'A RC Inovações entregou um sistema que superou as nossas expectativas. A equipa foi extremamente profissional e atenciosa durante todo o processo.'
      },
      client2: {
        name: 'Maria Oliveira',
        company: 'Comércio XYZ',
        text: 'O aplicativo desenvolvido pela RC Inovações transformou a nossa operação. Estamos muito satisfeitos com o resultado e com o apoio contínuo.'
      },
      client3: {
        name: 'Carlos Santos',
        company: 'Indústria 123',
        text: 'Recomendo fortemente os serviços da RC Inovações. O sistema personalizado que criaram para a nossa empresa foi fundamental para o crescimento do negócio.'
      }
    },
    contact: {
      title: 'Entre em Contacto',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      subject: 'Assunto',
      message: 'Mensagem',
      send: 'Enviar',
      address: 'Endereço',
      phoneContact: 'Telefone',
      emailContact: 'E-mail'
    },
    footer: {
      rights: 'Todos os direitos reservados',
      privacy: 'Política de Privacidade',
      terms: 'Termos de Uso'
    }
  },
  'en-US': {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      projects: 'Projects',
      contact: 'Contact'
    },
    hero: {
      title: 'Innovative Software Development Solutions',
      subtitle: 'We develop customized web, desktop, and mobile systems to boost your business.',
      cta: 'Contact Us'
    },
    about: {
      title: 'About RC Inovações',
      description: 'RC Inovações is a company specialized in system development, focused on delivering innovative and high-quality technological solutions. Our team of qualified professionals is prepared to meet the specific needs of your business, creating customized systems that enhance operational efficiency and drive growth.',
      mission: 'Mission',
      missionText: 'To develop technological solutions that transform and optimize processes, generating value for our clients.',
      vision: 'Vision',
      visionText: 'To be a reference in custom system development, recognized for excellence and innovation.',
      values: 'Values',
      valuesText: 'Innovation, Quality, Commitment, Ethics, and Customer Satisfaction.'
    },
    services: {
      title: 'Our Services',
      webDev: {
        title: 'Web Development',
        description: 'We create responsive, modern, and optimized websites and web systems to offer the best user experience. We use the most advanced technologies in the market.'
      },
      desktopDev: {
        title: 'Desktop Development',
        description: 'We develop robust and efficient desktop applications, ideal for corporate use, with intuitive interfaces and high performance.'
      },
      mobileDev: {
        title: 'Mobile Development',
        description: 'We create native and hybrid mobile applications for iOS and Android, with modern design and excellent user experience.'
      },
      customSystems: {
        title: 'Custom Systems',
        description: 'We develop tailored systems to meet the specific needs of your business, automating processes and increasing productivity.'
      }
    },
    projects: {
      title: 'Completed Projects',
      viewMore: 'View more'
    },
    testimonials: {
      title: 'Testimonials',
      client1: {
        name: 'John Smith',
        company: 'ABC Company',
        text: 'RC Inovações delivered a system that exceeded our expectations. The team was extremely professional and attentive throughout the process.'
      },
      client2: {
        name: 'Mary Johnson',
        company: 'XYZ Commerce',
        text: 'The application developed by RC Inovações transformed our operation. We are very satisfied with the result and the continuous support.'
      },
      client3: {
        name: 'Charles Brown',
        company: '123 Industry',
        text: 'I strongly recommend RC Inovações services. The custom system they created for our company was fundamental to business growth.'
      }
    },
    contact: {
      title: 'Contact Us',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      send: 'Send',
      address: 'Address',
      phoneContact: 'Phone',
      emailContact: 'Email'
    },
    footer: {
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use'
    }
  },
  'en-GB': {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      projects: 'Projects',
      contact: 'Contact'
    },
    hero: {
      title: 'Innovative Software Development Solutions',
      subtitle: 'We develop customised web, desktop, and mobile systems to boost your business.',
      cta: 'Contact Us'
    },
    about: {
      title: 'About RC Inovações',
      description: 'RC Inovações is a company specialised in system development, focused on delivering innovative and high-quality technological solutions. Our team of qualified professionals is prepared to meet the specific needs of your business, creating customised systems that enhance operational efficiency and drive growth.',
      mission: 'Mission',
      missionText: 'To develop technological solutions that transform and optimise processes, generating value for our clients.',
      vision: 'Vision',
      visionText: 'To be a reference in custom system development, recognised for excellence and innovation.',
      values: 'Values',
      valuesText: 'Innovation, Quality, Commitment, Ethics, and Customer Satisfaction.'
    },
    services: {
      title: 'Our Services',
      webDev: {
        title: 'Web Development',
        description: 'We create responsive, modern, and optimised websites and web systems to offer the best user experience. We use the most advanced technologies in the market.'
      },
      desktopDev: {
        title: 'Desktop Development',
        description: 'We develop robust and efficient desktop applications, ideal for corporate use, with intuitive interfaces and high performance.'
      },
      mobileDev: {
        title: 'Mobile Development',
        description: 'We create native and hybrid mobile applications for iOS and Android, with modern design and excellent user experience.'
      },
      customSystems: {
        title: 'Custom Systems',
        description: 'We develop tailored systems to meet the specific needs of your business, automating processes and increasing productivity.'
      }
    },
    projects: {
      title: 'Completed Projects',
      viewMore: 'View more'
    },
    testimonials: {
      title: 'Testimonials',
      client1: {
        name: 'John Smith',
        company: 'ABC Company',
        text: 'RC Inovações delivered a system that exceeded our expectations. The team was extremely professional and attentive throughout the process.'
      },
      client2: {
        name: 'Mary Johnson',
        company: 'XYZ Commerce',
        text: 'The application developed by RC Inovações transformed our operation. We are very satisfied with the result and the continuous support.'
      },
      client3: {
        name: 'Charles Brown',
        company: '123 Industry',
        text: 'I strongly recommend RC Inovações services. The custom system they created for our company was fundamental to business growth.'
      }
    },
    contact: {
      title: 'Contact Us',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      send: 'Send',
      address: 'Address',
      phoneContact: 'Phone',
      emailContact: 'Email'
    },
    footer: {
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use'
    }
  },
  'es': {
    nav: {
      home: 'Inicio',
      about: 'Acerca de',
      services: 'Servicios',
      projects: 'Proyectos',
      contact: 'Contacto'
    },
    hero: {
      title: 'Soluciones Innovadoras en Desarrollo de Software',
      subtitle: 'Desarrollamos sistemas personalizados, web, desktop y móviles para impulsar su negocio.',
      cta: 'Contáctenos'
    },
    about: {
      title: 'Sobre RC Inovações',
      description: 'RC Inovações es una empresa especializada en desarrollo de sistemas, enfocada en entregar soluciones tecnológicas innovadoras y de alta calidad. Nuestro equipo de profesionales calificados está preparado para atender las necesidades específicas de su negocio, creando sistemas a medida que potencian la eficiencia operativa e impulsan el crecimiento.',
      mission: 'Misión',
      missionText: 'Desarrollar soluciones tecnológicas que transformen y optimicen procesos, generando valor para nuestros clientes.',
      vision: 'Visión',
      visionText: 'Ser referencia en desarrollo de sistemas personalizados, reconocida por la excelencia e innovación.',
      values: 'Valores',
      valuesText: 'Innovación, Calidad, Compromiso, Ética y Satisfacción del Cliente.'
    },
    services: {
      title: 'Nuestros Servicios',
      webDev: {
        title: 'Desarrollo Web',
        description: 'Creamos sitios web y sistemas web responsivos, modernos y optimizados para ofrecer la mejor experiencia a los usuarios. Utilizamos las tecnologías más avanzadas del mercado.'
      },
      desktopDev: {
        title: 'Desarrollo Desktop',
        description: 'Desarrollamos aplicaciones desktop robustas y eficientes, ideales para uso corporativo, con interfaces intuitivas y alto rendimiento.'
      },
      mobileDev: {
        title: 'Desarrollo Móvil',
        description: 'Creamos aplicaciones móviles nativas e híbridas para iOS y Android, con diseño moderno y excelente experiencia de usuario.'
      },
      customSystems: {
        title: 'Sistemas Personalizados',
        description: 'Desarrollamos sistemas a medida para atender las necesidades específicas de su negocio, automatizando procesos y aumentando la productividad.'
      }
    },
    projects: {
      title: 'Proyectos Realizados',
      viewMore: 'Ver más'
    },
    testimonials: {
      title: 'Testimonios',
      client1: {
        name: 'Juan García',
        company: 'Empresa ABC',
        text: 'RC Inovações entregó un sistema que superó nuestras expectativas. El equipo fue extremadamente profesional y atento durante todo el proceso.'
      },
      client2: {
        name: 'María Rodríguez',
        company: 'Comercio XYZ',
        text: 'La aplicación desarrollada por RC Inovações transformó nuestra operación. Estamos muy satisfechos con el resultado y con el soporte continuo.'
      },
      client3: {
        name: 'Carlos López',
        company: 'Industria 123',
        text: 'Recomiendo fuertemente los servicios de RC Inovações. El sistema personalizado que crearon para nuestra empresa fue fundamental para el crecimiento del negocio.'
      }
    },
    contact: {
      title: 'Contáctenos',
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      subject: 'Asunto',
      message: 'Mensaje',
      send: 'Enviar',
      address: 'Dirección',
      phoneContact: 'Teléfono',
      emailContact: 'Correo electrónico'
    },
    footer: {
      rights: 'Todos los derechos reservados',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Uso'
    }
  },
  'it': {
    nav: {
      home: 'Home',
      about: 'Chi siamo',
      services: 'Servizi',
      projects: 'Progetti',
      contact: 'Contatti'
    },
    hero: {
      title: 'Soluzioni Innovative per lo Sviluppo Software',
      subtitle: 'Sviluppiamo sistemi personalizzati, web, desktop e mobile per far crescere la tua attività.',
      cta: 'Contattaci'
    },
    about: {
      title: 'Chi è RC Inovações',
      description: 'RC Inovações è un\'azienda specializzata nello sviluppo di sistemi, focalizzata sulla fornitura di soluzioni tecnologiche innovative e di alta qualità. Il nostro team di professionisti qualificati è pronto a soddisfare le esigenze specifiche della tua attività, creando sistemi personalizzati che migliorano l\'efficienza operativa e favoriscono la crescita.',
      mission: 'Missione',
      missionText: 'Sviluppare soluzioni tecnologiche che trasformino e ottimizzino i processi, generando valore per i nostri clienti.',
      vision: 'Visione',
      visionText: 'Essere un punto di riferimento nello sviluppo di sistemi personalizzati, riconosciuti per eccellenza e innovazione.',
      values: 'Valori',
      valuesText: 'Innovazione, Qualità, Impegno, Etica e Soddisfazione del Cliente.'
    },
    services: {
      title: 'I Nostri Servizi',
      webDev: {
        title: 'Sviluppo Web',
        description: 'Creiamo siti web e sistemi web responsive, moderni e ottimizzati per offrire la migliore esperienza agli utenti. Utilizziamo le tecnologie più avanzate sul mercato.'
      },
      desktopDev: {
        title: 'Sviluppo Desktop',
        description: 'Sviluppiamo applicazioni desktop robuste ed efficienti, ideali per uso aziendale, con interfacce intuitive e alte prestazioni.'
      },
      mobileDev: {
        title: 'Sviluppo Mobile',
        description: 'Creiamo applicazioni mobili native e ibride per iOS e Android, con design moderno ed eccellente esperienza utente.'
      },
      customSystems: {
        title: 'Sistemi Personalizzati',
        description: 'Sviluppiamo sistemi su misura per soddisfare le esigenze specifiche della tua attività, automatizzando processi e aumentando la produttività.'
      }
    },
    projects: {
      title: 'Progetti Realizzati',
      viewMore: 'Vedi di più'
    },
    testimonials: {
      title: 'Testimonianze',
      client1: {
        name: 'Giovanni Rossi',
        company: 'Azienda ABC',
        text: 'RC Inovações ha consegnato un sistema che ha superato le nostre aspettative. Il team è stato estremamente professionale e attento durante tutto il processo.'
      },
      client2: {
        name: 'Maria Bianchi',
        company: 'Commercio XYZ',
        text: 'L\'applicazione sviluppata da RC Inovações ha trasformato la nostra operazione. Siamo molto soddisfatti del risultato e del supporto continuo.'
      },
      client3: {
        name: 'Carlo Verdi',
        company: 'Industria 123',
        text: 'Raccomando vivamente i servizi di RC Inovações. Il sistema personalizzato che hanno creato per la nostra azienda è stato fondamentale per la crescita del business.'
      }
    },
    contact: {
      title: 'Contattaci',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefono',
      subject: 'Oggetto',
      message: 'Messaggio',
      send: 'Invia',
      address: 'Indirizzo',
      phoneContact: 'Telefono',
      emailContact: 'Email'
    },
    footer: {
      rights: 'Tutti i diritti riservati',
      privacy: 'Politica sulla Privacy',
      terms: 'Termini di Utilizzo'
    }
  }
} 